import { motion } from "framer-motion";
import Marquee from "react-fast-marquee";

const projects = [
  {
    src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/00j1sqth_Frame%202147225851.png",
    alt: "Nara Therapy mobile app",
    bg: "bg-lime-100",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/xtguaieb_Frame%202147225850.png",
    alt: "West African Franc wallet app",
    bg: "bg-blue-100",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/hcygbz3a_45.jpg",
    alt: "Fontalk — Connect, Build Credit, Thrive",
    bg: "bg-sky-950",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/zvb8bams_Frame%202147225848.png",
    alt: "Worth — build trust, one payment at a time",
    bg: "bg-emerald-900",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_site-starter-kit-6/artifacts/la9ybvdl_Frame%202147225849.png",
    alt: "Refer and Earn rewards app",
    bg: "bg-brand-900",
  },
];

export default function Hero() {
  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative pt-32 sm:pt-40 pb-0 bg-white"
    >
      {/* Heading */}
      <div className="max-w-5xl mx-auto px-6 sm:px-8 text-center">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          data-testid="hero-heading"
          className="font-display text-5xl sm:text-6xl lg:text-7xl font-semibold tracking-tighter leading-[1.05] text-zinc-950"
        >
          Building Products That Shape{" "}
          <span className="italic font-light text-zinc-800">Experiences</span>{" "}
          and Drive <span className="relative inline-block">
            Impact
            <span className="absolute -bottom-1 left-0 right-0 h-[6px] brand-gradient -z-0 rounded-full"></span>
          </span>
        </motion.h1>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.15, ease: "easeOut" }}
          data-testid="hero-subhead"
          className="mt-6 sm:mt-8 text-base sm:text-lg text-zinc-600 max-w-2xl mx-auto leading-relaxed"
        >
          I&apos;m Obiajulu Anayo, a product manager and designer with a passion
          for solving complex problems through user-centred design and strategy.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, delay: 0.3, ease: "easeOut" }}
          className="mt-8 sm:mt-10 flex flex-col sm:flex-row items-center justify-center gap-3"
        >
          <a
            href="https://calendar.app.google/iXZfcWqTPkusBQsi7"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="hero-book-session-btn"
            className="inline-flex items-center gap-2 bg-zinc-950 text-white hover:bg-brand-600 transition-colors text-sm font-medium px-6 py-3 rounded-full"
          >
            Book a Session
            <span className="inline-block h-1.5 w-1.5 rounded-full bg-brand-500"></span>
          </a>
          <a
            href="#projects"
            data-testid="hero-view-work-btn"
            className="inline-flex items-center gap-2 bg-white text-zinc-900 border border-zinc-200 hover:border-zinc-900 transition-colors text-sm font-medium px-6 py-3 rounded-full"
          >
            View my work
            <svg className="h-3.5 w-3.5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M7 17L17 7M9 7h8v8" strokeLinecap="round" strokeLinejoin="round"/></svg>
          </a>
        </motion.div>
      </div>

      {/* Marquee of project screenshots */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1, delay: 0.4 }}
        data-testid="hero-mockups-marquee"
        className="relative mt-16 sm:mt-20 marquee-mask-light"
      >
        <Marquee speed={40} gradient={false} pauseOnHover>
          {projects.concat(projects).map((p, i) => (
            <ProjectCard key={i} {...p} index={i} />
          ))}
        </Marquee>
      </motion.div>
    </section>
  );
}

function ProjectCard({ src, alt }) {
  return (
    <div className="mx-1 sm:mx-2 h-[420px] sm:h-[520px] flex items-start">
      <img
        src={src}
        alt={alt}
        loading="lazy"
        className="h-full w-auto max-w-none object-contain object-top select-none"
        draggable={false}
      />
    </div>
  );
}
